import { render, staticRenderFns } from "./resource-categories.vue?vue&type=template&id=4e08312f"
import script from "./resource-categories.vue?vue&type=script&lang=ts"
export * from "./resource-categories.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports